import { downloadBlobViaServiceWorker } from "./serviceWorkerDownload";

const MAX_DOWNLOAD_BYTES = 256 * 1024 * 1024;

type NativeSaveResult =
  | { ok: true }
  | { ok: false; canceled?: boolean; error?: string };

type NativeAttachmentBridge = {
  saveAttachment?: (
    bytes: ArrayBuffer,
    filename: string,
  ) => NativeSaveResult | Promise<NativeSaveResult>;
};

/**
 * Save a received Matrix attachment. Electron gets the Blob bytes directly;
 * ordinary browsers retain the existing service-worker download behavior.
 * Returns false only when the native save dialog was cancelled.
 */
export async function downloadReceivedAttachment(blob: Blob, filename: string): Promise<boolean> {
  const bridge = (window as Window & { ALGDesktop?: NativeAttachmentBridge }).ALGDesktop;
  if (bridge?.saveAttachment) {
    if (blob.size > MAX_DOWNLOAD_BYTES) {
      throw new Error("This file is too large to download in the app (256 MB limit).");
    }
    const result = await bridge.saveAttachment(await blob.arrayBuffer(), filename);
    if (result.ok) return true;
    if (result.canceled) return false;
    throw new Error(result.error || "The attachment could not be saved.");
  }

  await downloadBlobViaServiceWorker(blob, filename);
  return true;
}
